import { api } from '../api';
import type { 
  HealthcareProviderRegistrationRequest, 
  TourOperatorRegistrationRequest,
  TourOperatorAdminRegistrationRequest,
  AffiliatePartnerAdminRegistrationRequest,
  ProviderRegistrationResponse 
} from '@/types/provider';

export const providerApi = {
  // Register healthcare provider admin
  registerHealthcareProviderAdmin: async (data: {
    firstName: string;
    lastName: string;
    email: string;
    password: string;
    organizationName: string;
    phoneNumber?: string;
  }): Promise<ProviderRegistrationResponse> => {
    const response = await api.post('/providers/healthcare-provider-admin', data);
    return response.data.data;
  },

  // Register tour operator admin
  registerTourOperatorAdmin: async (data: TourOperatorAdminRegistrationRequest): Promise<ProviderRegistrationResponse> => {
    const response = await api.post('/providers/tour-operator-admin', data);
    return response.data.data;
  },

  // Register affiliate partner admin
  registerAffiliatePartnerAdmin: async (data: AffiliatePartnerAdminRegistrationRequest): Promise<ProviderRegistrationResponse> => {
    const response = await api.post('/providers/affiliate-partner-admin', data);
    return response.data.data;
  },

  // Register full healthcare provider (when ready)
  registerHealthcareProvider: async (data: HealthcareProviderRegistrationRequest): Promise<ProviderRegistrationResponse> => {
    const response = await api.post('/providers/healthcare-provider', data);
    return response.data.data;
  },

  // Register tour operator (when ready)
  registerTourOperator: async (data: TourOperatorRegistrationRequest): Promise<ProviderRegistrationResponse> => {
    const response = await api.post('/providers/tour-operator', data);
    return response.data.data;
  },
};